define("shared/components/shared/media-item-modal", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "ember-concurrency", "nprogress", "shared/utils/delete-media-item"], function (_exports, _component, _templateFactory, _object, _service, _utils, _component2, _emberConcurrency, _nprogress, _deleteMediaItem) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"ember-concurrency",0,"nprogress",0,"shared/utils/delete-media-item"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal
    @close={{@close}}
    @closeButtonQaClass="qa--alert_closeIcon"
    @navigate={{unless this.isEditing this.navigate}}
    as |modal|
  >
    {{#let (component (if @isMediaEditRouteExternal "link-to-external" "link-to")) as |DynamicLinkTo|}}
      <modal.card @hasSecondary={{@hasSecondary}} @portrait={{true}}>
        <div class="o--modal__mediaWrapper">
          {{#if @model.videoUrl}}
            <Shared::MediaItems::MediaItemVideo @mediaItem={{@model}} />
          {{else}}
            <Shared::MediaItems::ModalDisplay @mediaItem={{@model}} />
          {{/if}}
        </div>
        <div class="o--modalBody u--p__t__0 u--p__b">
          {{#if @editingCaption}}
            <div class="o--formWrapper u--m__tb__sm">
              <label>
                {{svg-jar "media-note" class="o--icon u--m__r"}}
                {{t "calendar.modal.media_note"}}
              </label>
              <Textarea
                @value={{@model.defaultCaption}}
                class="o--textareaCaption"
                disabled={{@model.isSaving}}
                id="textareaMediaNote"
                placeholder={{t "calendar.modal.empty_media_note"}}
              />
            </div>
            <Shared::Post::Secondary::Toggle
              @class="cMT--toggle u--relative u--m__t__xs u--p__lr__0"
              @mediaItem={{@mediaItem}}
              @postElementId={{@postElementId}}
              @toggleHashtagSuggestions={{@toggleSmartHashtags}}
              @toggleSavedCaptions={{@toggleCaptionTemplate}}
            />
            <div class="o--btnBar u--m__b u--text--right u--relative">
              <Shared::Ui::Button
                @onClick={{@cancelEditingCaption}}
                @text={{t "shared_words.close"}}
                @variant="outline"
              />
              <Shared::Ui::Button @onClick={{@saveEditedCaption}} @text={{t "shared_words.update"}} />
            </div>
            <hr />
          {{else}}
            <div class="o--formWrapper u--m__tb__sm">
              <label>
                {{svg-jar "media-note" class="o--icon u--m__r"}}
                {{t "calendar.modal.media_note"}}
              </label>
              <Shared::Ui::Button
                @class="u--m__l__sm u--text--sm u--text--uppercase"
                @onClick={{@editCaption}}
                @text={{t "shared_words.edit"}}
                @variant="actionLink"
              />
              {{! This needs to be a single line, otherwise it causes an indent at the beginning of the media note }}
              <p class="o--textareaCaption--view u--p__l__lg u--m__b__lg">{{@model.defaultCaption}}</p>
            </div>
          {{/if}}
          {{! Alt text }}
          {{#if @editingAltText}}
            <div class="o--formWrapper u--m__tb__sm">
              <label>
                {{svg-jar "alt-text" class="o--icon u--m__r"}}
                {{t "calendar.modal.media_alt_text"}}
              </label>
              <Textarea
                @value={{@model.altText}}
                class="o--textareaCaption qa--altText_shortDescription"
                disabled={{@model.isSaving}}
                id="textareaAltText"
                placeholder={{t "calendar.modal.empty_media_alt_text"}}
              />
            </div>
            <span
              class={{concat-classes
                (if (gt @altTextCount @maxAltTextCount) "u--text--danger")
                "qa--postmodal_char_count_error"
              }}
            >
              {{t "calendar.modal.alt_text_characters_left" count=this.altTextCharacterRemain}}
            </span>
            <div class="o--btnBar u--m__b u--text--right u--relative">
              <Shared::Ui::Button
                @onClick={{@cancelEditingAltText}}
                @text={{t "shared_words.close"}}
                @variant="outline"
                class="qa--mediamodal_altText_closeBtn"
              />
              <Shared::Ui::Button
                @isDisabled={{this.isUpdateAltTextDisabled}}
                @onClick={{@saveEditedAltText}}
                @text={{t "shared_words.update"}}
                class="qa--altText_saveBtn"
              />
            </div>
            <hr />
          {{else}}
            <div class="o--formWrapper u--m__tb__sm">
              <label class="qa--mediamodal_altText">
                {{svg-jar "alt-text" class="o--icon u--m__r"}}
                {{t "calendar.modal.media_alt_text"}}
              </label>
              <Shared::Ui::Button
                @class="u--m__l__sm u--text--sm u--text--uppercase"
                @onClick={{@editAltText}}
                @text={{t "shared_words.edit"}}
                @variant="actionLink"
                class="qa--mediamodal_altText_editBtn"
              />
              <p class="o--textareaCaption--view u--p__l__lg u--m__b__lg u--flex">
                {{@model.altText}}
              </p>
            </div>
          {{/if}}
          {{! Labels }}
          <label>
            {{svg-jar "label" class="o--icon u--m__r"}}
            {{t "media_items.labels.title"}}
          </label>
          <DynamicLinkTo @model={{@model.id}} @route="cluster.media.edit">
            <span class="u--m__l__xs u--text--sm u--text--uppercase e--customClass--toggle">
              {{t "shared_words.edit"}}
              <EmberTooltip @delay={{330}} @side="top">
                {{t "calendar.modal.labels.edit_in_library"}}
              </EmberTooltip>
            </span>
          </DynamicLinkTo>
          {{#if @hasLabels}}
            <div class="u--m__b u--clearfix">
              {{#each @model.labels as |itemLabel|}}
                <span class="cLB--label--sm u--m__b__xs {{if itemLabel.isSystemLabel 'cLB--label--system'}}">
                  {{itemLabel.canonicalTagName}}
                </span>
              {{/each}}
            </div>
          {{/if}}
        </div>
        <footer class="o--modalFooter">
          <div class="u--row">
            <div class="u--col__3">
              <Shared::Ui::Button
                @class="u--p__lr__sm qa--media_modal__delete_button"
                @isDisabled={{@model.isSaving}}
                @onClick={{fn this.destroyMediaItem @model}}
                @variant="mute"
                data-test-id="delete-media-item"
              >
                {{svg-jar "trash" class="o--icon"}}
                <EmberTooltip @delay={{330}} @side="top">
                  {{t "calendar.modal.icons.delete_media"}}
                </EmberTooltip>
              </Shared::Ui::Button>
              <Shared::Ui::Button
                @class="u--p__lr__sm qa--media_modal__open_in_library"
                @isDisabled={{@model.isSaving}}
                @onClick={{perform this.navigateToMediaLibrary}}
                @variant="mute"
              >
                <span>
                  {{svg-jar "media-view" class="o--icon"}}
                  <EmberTooltip @delay={{330}} @side="top">
                    {{t "calendar.modal.icons.edit_in_library"}}
                  </EmberTooltip>
                </span>
              </Shared::Ui::Button>
            </div>
            <div class="u--col__9 u--text--right h--allowMultiLineBtns {{if @editingCaption 'u--hide'}}">
              {{#if this.shouldShowCreatePostButton}}
                {{#if @socialProfile.hasLimitedPosts}}
                  <Shared::Button::Upgrade
                    @feature="getMorePosts"
                    @location="media modal more posts"
                    @socialProfileType={{@socialProfile.profileType}}
                    as |upgradeAction|
                  >
                    <Shared::Ui::Button @onClick={{upgradeAction}} @variant="none" class="u--text--light">
                      {{@socialProfile.postsLeft}}
                      <EmberTooltip @delay={{330}} @side="top">
                        {{t "media_items.update.max_posts"}}
                      </EmberTooltip>
                    </Shared::Ui::Button>
                  </Shared::Button::Upgrade>
                {{/if}}
                <Shared::Ui::Button
                  @class="qa--media_modal__primary_button"
                  @onClick={{this.startSchedulingNewPost}}
                  @text={{@createPostText}}
                  @variant="primary"
                />
              {{else if @showUpgradeButton}}
                <Shared::Button::Upgrade
                  @feature="getMorePosts"
                  @location="media item modal"
                  @socialProfileType={{@socialProfile.profileType}}
                  @text={{@rejectCreatePostReason}}
                />
              {{else if @rejectCreatePostReason}}
                <Shared::Ui::Button
                  @class="qa--media_modal__primary_button"
                  @isDisabled={{true}}
                  @onClick={{(noop)}}
                  @text={{@rejectCreatePostReason}}
                  @variant="primary"
                />
              {{/if}}
            </div>
          </div>
        </footer>
        <Shared::Post::Secondary::Wrapper
          @hasDirtyAttributes={{@hasDirtyAttributes}}
          @location="media_item"
          @mediaItem={{@mediaItem}}
          @post={{@post}}
          @postElementId={{@postElementId}}
          @rollbackSavedCaption={{@rollbackSavedCaption}}
          @savedCaptionToEdit={{@savedCaptionToEdit}}
          @setCaptionToEdit={{@setCaptionToEdit}}
          @socialProfile={{@socialProfile}}
          @toggleSecondary={{@toggleSecondary}}
        />
      </modal.card>
      {{#if @model.hasPosts}}
        <div class="o--modalCard--narrow" {{did-insert (perform @model.fetchVisiblePosts)}}>
          <div class="o--modalBody">
            <table class="o--table o--table--condensed o--table--hover u--m__b__0">
              <thead>
                <tr>
                  <th class="u--text--left">
                    {{t "calendar.modal.media_used_in"}}
                  </th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {{#each @model.visiblePosts as |post|}}
                  <Shared::MediaItems::PostCard @editPost={{@editPost}} @post={{post}} />
                {{/each}}
              </tbody>
            </table>
          </div>
        </div>
      {{/if}}
    {{/let}}
  </Shared::Modal>
  */
  {
    "id": "ksLxb6Oc",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@closeButtonQaClass\",\"@navigate\"],[[30,1],\"qa--alert_closeIcon\",[52,[51,[30,0,[\"isEditing\"]]],[30,0,[\"navigate\"]]]]],[[\"default\"],[[[[1,\"\\n\"],[44,[[50,[52,[30,3],\"link-to-external\",\"link-to\"],0,null,null]],[[[1,\"    \"],[8,[30,2,[\"card\"]],null,[[\"@hasSecondary\",\"@portrait\"],[[30,5],true]],[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"o--modal__mediaWrapper\"],[12],[1,\"\\n\"],[41,[30,6,[\"videoUrl\"]],[[[1,\"          \"],[8,[39,5],null,[[\"@mediaItem\"],[[30,6]]],null],[1,\"\\n\"]],[]],[[[1,\"          \"],[8,[39,6],null,[[\"@mediaItem\"],[[30,6]]],null],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--modalBody u--p__t__0 u--p__b\"],[12],[1,\"\\n\"],[41,[30,7],[[[1,\"          \"],[10,0],[14,0,\"o--formWrapper u--m__tb__sm\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,\"\\n              \"],[1,[28,[35,7],[\"media-note\"],[[\"class\"],[\"o--icon u--m__r\"]]]],[1,\"\\n              \"],[1,[28,[35,8],[\"calendar.modal.media_note\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[8,[39,9],[[24,0,\"o--textareaCaption\"],[16,\"disabled\",[30,6,[\"isSaving\"]]],[24,1,\"textareaMediaNote\"],[16,\"placeholder\",[28,[37,8],[\"calendar.modal.empty_media_note\"],null]]],[[\"@value\"],[[30,6,[\"defaultCaption\"]]]],null],[1,\"          \"],[13],[1,\"\\n          \"],[8,[39,10],null,[[\"@class\",\"@mediaItem\",\"@postElementId\",\"@toggleHashtagSuggestions\",\"@toggleSavedCaptions\"],[\"cMT--toggle u--relative u--m__t__xs u--p__lr__0\",[30,8],[30,9],[30,10],[30,11]]],null],[1,\"\\n          \"],[10,0],[14,0,\"o--btnBar u--m__b u--text--right u--relative\"],[12],[1,\"\\n            \"],[8,[39,11],null,[[\"@onClick\",\"@text\",\"@variant\"],[[30,12],[28,[37,8],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n            \"],[8,[39,11],null,[[\"@onClick\",\"@text\"],[[30,13],[28,[37,8],[\"shared_words.update\"],null]]],null],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"hr\"],[12],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,0],[14,0,\"o--formWrapper u--m__tb__sm\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,\"\\n              \"],[1,[28,[35,7],[\"media-note\"],[[\"class\"],[\"o--icon u--m__r\"]]]],[1,\"\\n              \"],[1,[28,[35,8],[\"calendar.modal.media_note\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[8,[39,11],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--m__l__sm u--text--sm u--text--uppercase\",[30,14],[28,[37,8],[\"shared_words.edit\"],null],\"actionLink\"]],null],[1,\"\\n\"],[1,\"            \"],[10,2],[14,0,\"o--textareaCaption--view u--p__l__lg u--m__b__lg\"],[12],[1,[30,6,[\"defaultCaption\"]]],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[41,[30,15],[[[1,\"          \"],[10,0],[14,0,\"o--formWrapper u--m__tb__sm\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,\"\\n              \"],[1,[28,[35,7],[\"alt-text\"],[[\"class\"],[\"o--icon u--m__r\"]]]],[1,\"\\n              \"],[1,[28,[35,8],[\"calendar.modal.media_alt_text\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[8,[39,9],[[24,0,\"o--textareaCaption qa--altText_shortDescription\"],[16,\"disabled\",[30,6,[\"isSaving\"]]],[24,1,\"textareaAltText\"],[16,\"placeholder\",[28,[37,8],[\"calendar.modal.empty_media_alt_text\"],null]]],[[\"@value\"],[[30,6,[\"altText\"]]]],null],[1,\"          \"],[13],[1,\"\\n          \"],[10,1],[15,0,[28,[37,12],[[52,[28,[37,13],[[30,16],[30,17]],null],\"u--text--danger\"],\"qa--postmodal_char_count_error\"],null]],[12],[1,\"\\n            \"],[1,[28,[35,8],[\"calendar.modal.alt_text_characters_left\"],[[\"count\"],[[30,0,[\"altTextCharacterRemain\"]]]]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"o--btnBar u--m__b u--text--right u--relative\"],[12],[1,\"\\n            \"],[8,[39,11],[[24,0,\"qa--mediamodal_altText_closeBtn\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,18],[28,[37,8],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n            \"],[8,[39,11],[[24,0,\"qa--altText_saveBtn\"]],[[\"@isDisabled\",\"@onClick\",\"@text\"],[[30,0,[\"isUpdateAltTextDisabled\"]],[30,19],[28,[37,8],[\"shared_words.update\"],null]]],null],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"hr\"],[12],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,0],[14,0,\"o--formWrapper u--m__tb__sm\"],[12],[1,\"\\n            \"],[10,\"label\"],[14,0,\"qa--mediamodal_altText\"],[12],[1,\"\\n              \"],[1,[28,[35,7],[\"alt-text\"],[[\"class\"],[\"o--icon u--m__r\"]]]],[1,\"\\n              \"],[1,[28,[35,8],[\"calendar.modal.media_alt_text\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[8,[39,11],[[24,0,\"qa--mediamodal_altText_editBtn\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--m__l__sm u--text--sm u--text--uppercase\",[30,20],[28,[37,8],[\"shared_words.edit\"],null],\"actionLink\"]],null],[1,\"\\n            \"],[10,2],[14,0,\"o--textareaCaption--view u--p__l__lg u--m__b__lg u--flex\"],[12],[1,\"\\n              \"],[1,[30,6,[\"altText\"]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"        \"],[10,\"label\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"label\"],[[\"class\"],[\"o--icon u--m__r\"]]]],[1,\"\\n          \"],[1,[28,[35,8],[\"media_items.labels.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[30,4],null,[[\"@model\",\"@route\"],[[30,6,[\"id\"]],\"cluster.media.edit\"]],[[\"default\"],[[[[1,\"\\n          \"],[10,1],[14,0,\"u--m__l__xs u--text--sm u--text--uppercase e--customClass--toggle\"],[12],[1,\"\\n            \"],[1,[28,[35,8],[\"shared_words.edit\"],null]],[1,\"\\n            \"],[8,[39,14],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,8],[\"calendar.modal.labels.edit_in_library\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"],[41,[30,21],[[[1,\"          \"],[10,0],[14,0,\"u--m__b u--clearfix\"],[12],[1,\"\\n\"],[42,[28,[37,16],[[28,[37,16],[[30,6,[\"labels\"]]],null]],null],null,[[[1,\"              \"],[10,1],[15,0,[29,[\"cLB--label--sm u--m__b__xs \",[52,[30,22,[\"isSystemLabel\"]],\"cLB--label--system\"]]]],[12],[1,\"\\n                \"],[1,[30,22,[\"canonicalTagName\"]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[22]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n      \"],[10,\"footer\"],[14,0,\"o--modalFooter\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"u--col__3\"],[12],[1,\"\\n            \"],[8,[39,11],[[24,\"data-test-id\",\"delete-media-item\"]],[[\"@class\",\"@isDisabled\",\"@onClick\",\"@variant\"],[\"u--p__lr__sm qa--media_modal__delete_button\",[30,6,[\"isSaving\"]],[28,[37,17],[[30,0,[\"destroyMediaItem\"]],[30,6]],null],\"mute\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,7],[\"trash\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n              \"],[8,[39,14],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,8],[\"calendar.modal.icons.delete_media\"],null]],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"]],[]]]]],[1,\"\\n            \"],[8,[39,11],null,[[\"@class\",\"@isDisabled\",\"@onClick\",\"@variant\"],[\"u--p__lr__sm qa--media_modal__open_in_library\",[30,6,[\"isSaving\"]],[28,[37,18],[[30,0,[\"navigateToMediaLibrary\"]]],null],\"mute\"]],[[\"default\"],[[[[1,\"\\n              \"],[10,1],[12],[1,\"\\n                \"],[1,[28,[35,7],[\"media-view\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n                \"],[8,[39,14],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n                  \"],[1,[28,[35,8],[\"calendar.modal.icons.edit_in_library\"],null]],[1,\"\\n                \"]],[]]]]],[1,\"\\n              \"],[13],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[15,0,[29,[\"u--col__9 u--text--right h--allowMultiLineBtns \",[52,[30,7],\"u--hide\"]]]],[12],[1,\"\\n\"],[41,[30,0,[\"shouldShowCreatePostButton\"]],[[[41,[30,23,[\"hasLimitedPosts\"]],[[[1,\"                \"],[8,[39,19],null,[[\"@feature\",\"@location\",\"@socialProfileType\"],[\"getMorePosts\",\"media modal more posts\",[30,23,[\"profileType\"]]]],[[\"default\"],[[[[1,\"\\n                  \"],[8,[39,11],[[24,0,\"u--text--light\"]],[[\"@onClick\",\"@variant\"],[[30,24],\"none\"]],[[\"default\"],[[[[1,\"\\n                    \"],[1,[30,23,[\"postsLeft\"]]],[1,\"\\n                    \"],[8,[39,14],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n                      \"],[1,[28,[35,8],[\"media_items.update.max_posts\"],null]],[1,\"\\n                    \"]],[]]]]],[1,\"\\n                  \"]],[]]]]],[1,\"\\n                \"]],[24]]]]],[1,\"\\n\"]],[]],null],[1,\"              \"],[8,[39,11],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"qa--media_modal__primary_button\",[30,0,[\"startSchedulingNewPost\"]],[30,25],\"primary\"]],null],[1,\"\\n\"]],[]],[[[41,[30,26],[[[1,\"              \"],[8,[39,19],null,[[\"@feature\",\"@location\",\"@socialProfileType\",\"@text\"],[\"getMorePosts\",\"media item modal\",[30,23,[\"profileType\"]],[30,27]]],null],[1,\"\\n\"]],[]],[[[41,[30,27],[[[1,\"              \"],[8,[39,11],null,[[\"@class\",\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[\"qa--media_modal__primary_button\",true,[28,[37,20],null,null],[30,27],\"primary\"]],null],[1,\"\\n            \"]],[]],null]],[]]]],[]]],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,21],null,[[\"@hasDirtyAttributes\",\"@location\",\"@mediaItem\",\"@post\",\"@postElementId\",\"@rollbackSavedCaption\",\"@savedCaptionToEdit\",\"@setCaptionToEdit\",\"@socialProfile\",\"@toggleSecondary\"],[[30,28],\"media_item\",[30,8],[30,29],[30,9],[30,30],[30,31],[30,32],[30,23],[30,33]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"],[41,[30,6,[\"hasPosts\"]],[[[1,\"      \"],[11,0],[24,0,\"o--modalCard--narrow\"],[4,[38,22],[[28,[37,18],[[30,6,[\"fetchVisiblePosts\"]]],null]],null],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--modalBody\"],[12],[1,\"\\n          \"],[10,\"table\"],[14,0,\"o--table o--table--condensed o--table--hover u--m__b__0\"],[12],[1,\"\\n            \"],[10,\"thead\"],[12],[1,\"\\n              \"],[10,\"tr\"],[12],[1,\"\\n                \"],[10,\"th\"],[14,0,\"u--text--left\"],[12],[1,\"\\n                  \"],[1,[28,[35,8],[\"calendar.modal.media_used_in\"],null]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,\"th\"],[12],[13],[1,\"\\n                \"],[10,\"th\"],[12],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,16],[[28,[37,16],[[30,6,[\"visiblePosts\"]]],null]],null],null,[[[1,\"                \"],[8,[39,23],null,[[\"@editPost\",\"@post\"],[[30,35],[30,34]]],null],[1,\"\\n\"]],[34]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null]],[4]]]],[2]]]]]],[\"@close\",\"modal\",\"@isMediaEditRouteExternal\",\"DynamicLinkTo\",\"@hasSecondary\",\"@model\",\"@editingCaption\",\"@mediaItem\",\"@postElementId\",\"@toggleSmartHashtags\",\"@toggleCaptionTemplate\",\"@cancelEditingCaption\",\"@saveEditedCaption\",\"@editCaption\",\"@editingAltText\",\"@altTextCount\",\"@maxAltTextCount\",\"@cancelEditingAltText\",\"@saveEditedAltText\",\"@editAltText\",\"@hasLabels\",\"itemLabel\",\"@socialProfile\",\"upgradeAction\",\"@createPostText\",\"@showUpgradeButton\",\"@rejectCreatePostReason\",\"@hasDirtyAttributes\",\"@post\",\"@rollbackSavedCaption\",\"@savedCaptionToEdit\",\"@setCaptionToEdit\",\"@toggleSecondary\",\"post\",\"@editPost\"],false,[\"shared/modal\",\"unless\",\"let\",\"component\",\"if\",\"shared/media-items/media-item-video\",\"shared/media-items/modal-display\",\"svg-jar\",\"t\",\"textarea\",\"shared/post/secondary/toggle\",\"shared/ui/button\",\"concat-classes\",\"gt\",\"ember-tooltip\",\"each\",\"-track-array\",\"fn\",\"perform\",\"shared/button/upgrade\",\"noop\",\"shared/post/secondary/wrapper\",\"did-insert\",\"shared/media-items/post-card\"]]",
    "moduleName": "shared/components/shared/media-item-modal.hbs",
    "isStrictMode": false
  });

  let MediaItemModalComponent = (_class = class MediaItemModalComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "router", _descriptor, this);

      _initializerDefineProperty(this, "mediaNavigation", _descriptor2, this);

      _initializerDefineProperty(this, "auth", _descriptor3, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor4, this);

      _initializerDefineProperty(this, "intl", _descriptor5, this);

      _initializerDefineProperty(this, "errors", _descriptor6, this);

      _initializerDefineProperty(this, "schedule", _descriptor7, this);
    }

    get altTextCharacterRemain() {
      return this.args.maxAltTextCount - this.args.altTextCount;
    }

    get hasNoSocialProfile() {
      return (0, _utils.isEmpty)(this.auth.currentGroup.socialProfiles);
    }

    get isEditing() {
      return this.args.editingAltText || this.args.editingCaption;
    }

    get isUpdateAltTextDisabled() {
      return this.args.altTextCount > this.args.maxAltTextCount;
    }

    get shouldShowCreatePostButton() {
      return (this.hasNoSocialProfile || this.args.canCreatePost) && !this.args.editingAltText && !this.args.editingCaption;
    }

    navigate(isPositive) {
      this.mediaNavigation.navigate(this.args.route, isPositive);
    }

    *navigateToMediaLibrary() {
      if (this.args.model.get('hasDirtyAttributes')) {
        const didConfirm = yield this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
          description: this.intl.t('shared_phrases.changes_not_saved'),
          confirmButton: this.intl.t('shared_words.leave')
        });

        if (!didConfirm) {
          return;
        }

        try {
          yield this.args.model.rollbackAttributes();
        } catch (adapterError) {
          this.errors.handleAdapter(adapterError);
        }
      }

      this.router.transitionTo('cluster.media.edit', this.args.model.id);
    }

    startSchedulingNewPost() {
      this.schedule.startSchedulingNewPost([this.args.mediaItem], this.args.location);
    }

    async destroyMediaItem(mediaItem) {
      const didConfirm = await this.dialogManager.confirmation(this.intl.t('media_items.update.confirm_destroy'), {
        description: this.intl.t('media_items.update.confirm_destroy_posts'),
        confirmButton: this.intl.t('shared_words.delete')
      });

      if (didConfirm) {
        try {
          _nprogress.default.start();

          await (0, _deleteMediaItem.default)(mediaItem);

          _nprogress.default.done();

          this.router.replaceWith('cluster.schedule.calendar');
        } catch (error) {
          this.errors.log(error);
        }
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "mediaNavigation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "schedule", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "navigate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "navigate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToMediaLibrary", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToMediaLibrary"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startSchedulingNewPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "startSchedulingNewPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "destroyMediaItem", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "destroyMediaItem"), _class.prototype)), _class);
  _exports.default = MediaItemModalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MediaItemModalComponent);
});